<template>
  <div class="tp-pagination-container">
    <div class="tp-pagination-left">
      <span>{{pageSize}}/Page, {{ total }} in Total</span>
      <!--<el-select-->
        <!--:value="pageSize"-->
        <!--class="pagesize-container"-->
        <!--popper-class="pagesize-dropdown"-->
        <!--@change="handleSizeChange"-->
      <!--&gt;-->
        <!--<el-option :value="15" label="15/page"></el-option>-->
        <!--<el-option :value="50" label="50/page"></el-option>-->
        <!--<el-option :value="100" label="100/page"></el-option>-->
      <!--</el-select>-->

    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :page-size="pageSize"
      :current-page="currentPage"
      layout="prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
  export default {
    name: 'commonPagination',
    props: {
      total: {
        type: Number,
        default: 0
      },
      pageSize: {
        type: Number,
        default: 15
      },
      currentPage: {
        type: Number,
        default: 0
      }
    },
    methods: {
      handleCurrentChange(value) {
        this.$emit('handleCurrentChange', value)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .tp-pagination-container {
    margin-right: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /deep/ * {
      font-weight: 500;
    }

    .tp-pagination-left {
      margin-right: 24px;
      display: flex;
      align-items: center;
      color: #000000;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      .tp-pagesize-container {
        width: 102px;
        ::v-deep {
          .el-input__inner {
            padding-left: 10px;
            line-height: 32px;
            height: 32px;
            font-size: 12px;
            color: #323c47;
          }
          .el-input__icon {
            line-height: 32px;
          }
        }
      }
    }

    ::v-deep {
      .el-pagination{
        padding-top: 0;
        padding-bottom: 0;
        color: #000;
        font-weight: 500;
      }
      .btn-prev,.btn-next{
        border-radius: 2px;
        border: solid 1px #dadce1;
        min-width: 32px;
        text-align: center;
        padding: 0;
        width: 32px;
        height: 32px;
      }
      .btn-prev{
        margin-right: 4px;
      }
      .btn-next{
        margin-left: 4px;
      }
      .el-pager li {
        padding: 0 11px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        min-width: 32px;
        border: solid 1px #dadce1;
        border-radius: 2px;
        margin-right: 4px;
        font-size: 14px;

        &:last-child{
          margin-right: 0;
        }

        &.active{
          border-color: #4066d4;
        }
      }
    }
  }
</style>
